module.exports = __webpack_public_path__ + "img/Saudi Arabia .cb6fc489.gif";